/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_WorkflowInputs */

const cs_enum_entity_workflow = /** @type {(inputs: Enum_Entity_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow`)
};

const en_enum_entity_workflow = /** @type {(inputs: Enum_Entity_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow`)
};

/**
* | output |
* | --- |
* | "Workflow" |
*
* @param {Enum_Entity_WorkflowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_workflow = /** @type {((inputs?: Enum_Entity_WorkflowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_WorkflowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_workflow(inputs)
	return cs_enum_entity_workflow(inputs)
});